import type { FC } from 'react';

import type { CloudNextHopKind } from '@ipfabric/utils';
import type { DeviceViewEntityId } from 'components/DeviceView/deviceViewTypes';
import { CloudResourceLink } from './CloudResourceLink';
import type { CloudConstructDecisionEvent } from './cloudDecisionEvent';

interface Props {
  deviceViewEntityId: DeviceViewEntityId;
  event: CloudConstructDecisionEvent;
}

const routeTypeLabel: { [Kind in CloudNextHopKind]: string } = {
  CLOUD_NETWORK: 'cloud network',
  DROP: 'blackhole',
  GATEWAY: 'gateway',
  INSTANCE: 'instance',
  INTERNET: 'internet',
  INTERNET_GATEWAY: 'internet gateway',
  IP_ADDRESS: 'IP address',
  LOCAL: 'local',
  NAT_GATEWAY: 'NAT gateway',
  NETWORK_INTERFACE: 'network interface',
  PEERING: 'peering',
  SUBNET: 'subnet',
  TRANSIT_GATEWAY: 'transit gateway',
};

// One row of a cloud construct's decision table (NIM-25155/NIM-25156/NIM-25157).
export const CloudDecisionCell: FC<Props> = (props) => {
  const { deviceViewEntityId, event } = props;
  switch (event.type) {
    case 'cloud vnic ip forwarding':
      return (
        <>
          {`IP forwarding source/destination check (${event.ip}): `}
          {event.passed ? 'passed' : 'failed'}
        </>
      );
    case 'cloud vnic workload handoff':
      return <>{`Delivered to workload ${event.destinationIp}`}</>;
    case 'cloud route match':
      return (
        <>
          {'Route table '}
          <CloudResourceLink
            deviceViewEntityId={deviceViewEntityId}
            id={event.routeTableId}
            kind='routeTable'
          />
          {' match '}
          <CloudResourceLink
            deviceViewEntityId={deviceViewEntityId}
            id={event.destinationCidr}
            kind='route'
            routeTableId={event.routeTableId}
          />
          {` type ${routeTypeLabel[event.nextHopKind]}`}
        </>
      );
  }
};
